import React from 'react';
import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import Logs from './Logs';
import StudentRefundDetail from './StudentRefundDetail';


const ViewStudentRefundDetail=({details,logs,setLoader,refundFlow,dropdownData})=>{

    return(
      <>
      <StudentRefundDetail dropdownData={dropdownData} details={details} setLoader={setLoader} refundFlow={refundFlow}/>
      <Logs rowList={logs}/>
      </>
    );

}
export default ViewStudentRefundDetail